"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const Popup_1 = __importDefault(require("../SettingsPopup/Popup"));
const tab_1 = __importDefault(require("../SettingsPopup/tab"));
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function ToolsPainSettingsPopup({ type, isPulsating, onSelectType, onChangePulsating, }) {
    const bridge = (0, bridge_1.useBridge)();
    const selectSphere = () => {
        onSelectType(bridge_schema_1.ToolType.PainSphere);
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdatePain({ type: bridge_schema_1.ToolType.PainSphere });
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.PainSphere,
            currentOptions: { type: bridge_schema_1.ToolType.PainSphere, switches: [true] },
        });
    };
    const selectBrush = () => {
        onSelectType(bridge_schema_1.ToolType.PainBrush);
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdatePain({ type: bridge_schema_1.ToolType.PainBrush });
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.PainBrush,
            currentOptions: { type: bridge_schema_1.ToolType.PainBrush, switches: [true] },
        });
    };
    const handleChangePulsating = (checked) => {
        onChangePulsating(checked);
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdatePain({ isPulsating: checked });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 5,
            toggleOptions: { checkboxNumber: 0, val: checked },
            type: type,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(Popup_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.title), "data-e2e": 'ToolsPainSettingsPopup_ToolsSettingsPopup', children: [(0, jsx_runtime_1.jsxs)(Tabs, { "data-e2e": 'ToolsPainSettingsPopup_Tabs', children: [(0, jsx_runtime_1.jsx)(tab_1.default, { selected: type === bridge_schema_1.ToolType.PainSphere, icon: ui_1.Icons.Pain_Sphere, onClick: selectSphere, "data-e2e": 'ToolsPainSettingsPopup_ToolsSettingsTab', children: (0, i18n_1.Localized)(i18n_1.Strings.tools.pain.sphere) }), (0, jsx_runtime_1.jsx)(tab_1.default, { icon: ui_1.Icons.Pain_Brush, selected: type === bridge_schema_1.ToolType.PainBrush, onClick: selectBrush, "data-e2e": 'ToolsPainSettingsPopup_ToolsSettingsTab', children: (0, i18n_1.Localized)(i18n_1.Strings.tools.pain.brush) })] }), (0, jsx_runtime_1.jsxs)(Hint, { "data-e2e": 'ToolsPainSettingsPopup_Hint', children: [(0, i18n_1.Localized)(i18n_1.Strings.tools.pain.pulsating), (0, jsx_runtime_1.jsx)(HintSwitch, { checked: isPulsating, onChange: handleChangePulsating, "data-e2e": 'ToolsPainSettingsPopup_HintSwitch' })] })] }));
}
exports.default = ToolsPainSettingsPopup;
const Tabs = styled_components_1.default.div `
  display: flex;
  justify-content: center;

  margin: 0 0 20px 0;
  padding: 10px 0 0 0;

  background: ${props => props.theme.primary};
  border-bottom: 1px solid ${props => props.theme.tools.spurs.headerBorder};
`;
const Hint = styled_components_1.default.div `
  display: flex;

  margin: 0 0 20px 0;
  padding: 0 20px;

  color: ${props => props.theme.text};

  font-size: 14px;
`;
const HintSwitch = (0, styled_components_1.default)(ui_1.Switch) `
  margin: auto 0 auto auto;
`;
